import * as React from "react"

import bem from "../../../bem"
import { connect } from "react-redux"
import NotificationMessage from "./NotificationMessage"
import { GlobalState } from "../../../store"
import { mapDispatchToProps, DispatchProps } from "../actions"

import "./Notifications.scss"

const b = bem.with("NewUI__notifications")

type StateProps = Notifications.Notifications

type Props = StateProps & DispatchProps

interface State {
    notifications: Notifications.NotificationMessage[]
}

export class Notifications extends React.Component<Props, State> {
    keys: WeakMap<Notifications.NotificationMessage, number>
    nextKey: number

    constructor(props: Props) {
        super(props)
        this.keys = new WeakMap()
        this.nextKey = 0
    }

    render(): JSX.Element {
        const { messages } = this.props
        return (
            <div className={b()}>
                {messages.map((m) => (
                    <NotificationMessage
                        data={m}
                        key={this.getKey(m)}
                        dismiss={this.dismissMessage}
                        expand={this.expandMessage}
                    />
                ))}
            </div>
        )
    }

    expandMessage = (
        message: Notifications.NotificationMessage,
        expanded: boolean,
    ): void => {
        const { expandMessage } = this.props
        expandMessage(message.uuid, expanded)
    }

    dismissMessage = (message: Notifications.NotificationMessage): void => {
        const { removeMessage } = this.props
        removeMessage(message)
    }

    getKey = (notification: Notifications.NotificationMessage): number => {
        if (!this.keys.has(notification)) {
            this.keys.set(notification, this.nextKey++)
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.keys.get(notification)!
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.notifications

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)
